<template>
  <BackofficeLayout :title="title" :loading="loading" :breadcrumb="breadcrumb">
    <div class="wrapper">
      <div class="main">
        <div class="statistic-panel">
          <div class="statistic statistic--blue">
            <v-icon class="statistic-icon">mdi-calendar-blank</v-icon>
            <div class="d-flex flex-column justify-center">
              <p class="statistic-caption">
                {{ $t("message.common.academic_year") }}
              </p>
              <p class="statistic-value">
                {{ registrationForm?.semester_year ?? "-" }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--navy">
            <v-icon class="statistic-icon">mdi-school</v-icon>
            <div class="d-flex flex-column justify-center">
              <p class="statistic-caption">
                {{ $t("message.common.required_amount") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_student || 0 }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--brown">
            <v-icon class="statistic-icon">mdi-account-multiple</v-icon>
            <div class="d-flex flex-column justify-center">
              <p class="statistic-caption">
                {{ $t("message.registration_form.applicants") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_register_student || 0 }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--orange">
            <v-icon class="statistic-icon">mdi-check-circle</v-icon>
            <div class="d-flex flex-column justify-center">
              <p class="statistic-caption">
                {{ $t("message.registration_form.confirmed") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_confirmation_student }}
              </p>
            </div>
          </div>
          <div class="statistic statistic--gold">
            <v-icon class="statistic-icon">monetization_on</v-icon>
            <div class="d-flex flex-column justify-center">
              <p class="statistic-caption">
                {{ $t("message.registration_form.application_fee") }}
              </p>
              <p class="statistic-value">
                {{ summary.total_fee | currency }}
              </p>
            </div>
          </div>
        </div>
        <v-sheet class="px-5 py-5 radius-10px" color="white" rounded elevation="1">
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters>
                <v-col cols="3">
                  <p class="form-title">
                    {{ $t("message.registration_form.application_detail") }}
                  </p>
                </v-col>
                <v-col cols="9">
                  <v-row class="flex-column row-column" no-gutters>
                    <v-col>
                      <v-row class="row-column" no-gutters>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t("message.registration_form.application_title")
                            }}</label>
                            <p>
                              {{ registrationForm?.register_name ?? "-" }}
                            </p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.application_opening_date"
                              )
                            }}</label>
                            <p>{{ openingDateText }}</p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.application_closing_date"
                              )
                            }}</label>
                            <p>{{ closingDateText }}</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="row-column" no-gutters>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t("message.registration_form.application_fee")
                            }}</label>
                            <p>{{ feeText }}</p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.deadline_of_payment"
                              )
                            }}</label>
                            {{ paymentEndDateText }}
                          </div>
                        </v-col>
                        <v-col>&nbsp;</v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="row-column" no-gutters>
                        <v-col>
                          <div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.announcement_of_qualify_candidates_date"
                              )
                            }}</label>
                            <p>{{ examAuthorizeAnnouncementDateText }}</p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{ $t("message.common.time") }}</label>
                            <p>{{ examAuthorizeAnnouncementTimeText }}</p>
                          </div>
                        </v-col>
                        <v-col>&nbsp;</v-col>
                      </v-row>
                    </v-col>

                    <v-col>
                      <v-row class="row-column" no-gutters>
                        <v-col>
                          <div class="form-meta">
                            <label
                              >{{
                                $t(
                                  "message.registration_form.announcement_of_examination_result"
                                )
                              }}
                              ({{
                                $t("message.registration_form.first_round")
                              }})</label
                            >
                            <p>{{ announcementExamResultDateText }}</p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{ $t("message.common.time") }}</label>
                            <p>{{ announcementExamResultTimeText }}</p>
                          </div>
                        </v-col>
                        <v-col
                          ><div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.deadline_of_confirmation"
                              )
                            }}</label>
                            <p>
                              {{ announcementExamResultDeadlineDateText }}
                            </p>
                          </div></v-col
                        >
                      </v-row>
                    </v-col>

                    <v-col>
                      <v-row class="row-column" no-gutters>
                        <v-col>
                          <div class="form-meta">
                            <label
                              >{{
                                $t(
                                  "message.registration_form.announcement_of_examination_result"
                                )
                              }}
                              ({{
                                $t("message.registration_form.reserve_round")
                              }})</label
                            >
                            <p>
                              {{ reservedAnnouncementExamResultDateText }}
                            </p>
                          </div>
                        </v-col>
                        <v-col>
                          <div class="form-meta">
                            <label>{{ $t("message.common.time") }}</label>
                            <p>
                              {{ reservedAnnouncementExamResultTimeText }}
                            </p>
                          </div>
                        </v-col>
                        <v-col
                          ><div class="form-meta">
                            <label>{{
                              $t(
                                "message.registration_form.deadline_of_confirmation"
                              )
                            }}</label>
                            <p>
                              {{
                                reservedAnnouncementExamResultDeadlineDateText
                              }}
                            </p>
                          </div></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="auto">
              <v-btn
                color="primary"
                outlined
                width="40"
                height="40"
                tile
                :style="{
                  'border-radius': '10px',
                  'min-width': 'unset',
                }"
                @click="downloadExcel"
              >
                <v-icon class="icon--primary">mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet color="white" class="radius-10px" elevation="1">
          <v-sheet class="px-5 py-5 radius-10px" elevation="0">
            <v-row class="flex-column row-column" no-gutters>
              <v-col>
                <p class="form-title">
                  {{
                    $t("message.registration_form.curriculum_and_grade_level")
                  }}
                </p>
              </v-col>
              <v-col>
                <div class="form-row form-row-gap--xl">
                  <div class="form-row form-row-gap--sm mb-0">
                    <v-text-field
                      v-model="keyword"
                      outlined
                      :placeholder="
                        $t('message.registration_form.search_by_curriculum')
                      "
                      prepend-inner-icon="mdi-magnify"
                      required
                      dense
                      hide-details
                      style="width: 410px"
                    ></v-text-field>
                    <v-btn
                      v-if="keyword"
                      color="primary"
                      outlined
                      width="90"
                      @click="search"
                    >
                      {{ $t("message.common.search") }}
                    </v-btn>
                    <v-btn
                      v-else
                      color="gray"
                      outlined
                      width="90"
                      @click="search"
                    >
                      {{ $t("message.common.search") }}
                    </v-btn>
                  </div>

                  <!-- <v-select
                    v-model="selectedStudentYearId"
                    @change="changeStudentYear"
                    outlined
                    :items="studentYear"
                    :item-text="`label_${$i18n.locale}`"
                    item-value="value"
                    prepend-inner-icon="mdi-filter-variant"
                    dense
                    hide-details
                    style="width: 240px"
                  ></v-select> -->
                </div>
              </v-col>
            </v-row>
          </v-sheet>
          <v-data-table
            class="custom-data-table custom-data-table--color"
            @update:items-per-page="handleChangePageSize"
            @update:page="handleChangePage"
            :page.sync="page"
            :options.sync="options"
            :headers="headers"
            :items="registrationPlan"
            :server-items-length="total"
            :items-per-page="pageSize"
            :footer-props="{
              'page-text': `${pageSizeText} ${$t(
                'message.common.pagination.of'
              )} ${total}`,
              'items-per-page-text': `${$t(
                'message.common.pagination.row_per_page'
              )}:`,
              'items-per-page-options': pageSizeOption,
            }"
            hide-default-header
            :hide-default-footer="registrationPlan <= 0"
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th
                    v-for="item in headers"
                    :key="item.value"
                    class="column"
                    :style="{ width: `${item.width}` }"
                  >
                    <div
                      v-if="item.sortable"
                      class="custom-table-header"
                      @click="handleChangeSort(item.sort)"
                    >
                      {{ item.text }}
                      <template v-if="item.sort === sort">
                        <v-icon v-if="sortDirection === 'desc'" small
                          >mdi-chevron-up</v-icon
                        >
                        <v-icon v-else small>mdi-chevron-down</v-icon>
                      </template>
                      <template v-else>
                        <v-icon small>mdi-unfold-more-horizontal</v-icon>
                      </template>
                    </div>
                    <div v-else>
                      {{ item.text }}
                    </div>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:[`item.total_fee`]="{ item }">
              {{ item.total_fee | currency }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <!-- <v-row
                v-if="registrationForm && item"
                justify="space-around"
                align="center"
                no-gutters
              > -->
                <div class="custom-table-action">
                    <!-- <a>
                        <v-icon
                        :class="!item.total_register ? 'icon--disabled' : ''" small
                        @click.prevent="downloadPdf(item)">mdi-download
                        </v-icon>
                    </a> -->
                    <router-link
                    class="icon--link"
                    :to="`/registration/calendar/${registrationForm.id}/grade-plans/${item.id}`"
                    >
                    <v-icon small>mdi-eye</v-icon>
                    </router-link>
                </div>
              <!-- </v-row> -->
            </template>
            <template v-slot:no-data>
              <div
                class="custom-data-table-empty-data custom-data-table-empty-data-small"
              >
                <div>
                  <v-icon class="mb-2" large>mdi-close-box</v-icon>
                  <p>{{ $t("message.common.data_not_found") }}</p>
                </div>
              </div>
            </template>
          </v-data-table>
          <VueHtml2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :manual-pagination="true"
            :pdf-quality="2"
            pdf-content-width="100%"
            :html-to-pdf-options="pdfOption"
            ref="html2pdf"
          >
            <section slot="pdf-content">
              <ApplicationPart
                v-if="registrationFormDetail && organizationDetail"
                :registrationFormDetail="registrationFormDetail"
                :organizationDetail="organizationDetail"
                :studentDataList="studentDataList"
                :reportTitle="reportTitle"
                :programName="programName"
              />
            </section>
          </VueHtml2pdf>
        </v-sheet>
      </div>
    </div>
  </BackofficeLayout>
</template>

<script>
import BackofficeLayout from "@/components/common/BackofficeLayout";
import * as services from "@/services";
import * as dateUtils from "@/utils/date";
import { calculateCurrentPage } from "@/utils/pagination";
import {
  // FORM_STATUS_TH,
  PAGE_SIZE_OPTIONS,
  OPPOSITE_SORT,
  DEFAULT_PAGE_SIZE,
} from "@/constants";
import router from "@/router";
import i18n from "@/i18n";
import VueHtml2pdf from "vue-html2pdf";
import ApplicationPart from "@/components/fileElement/ApplicantPart.vue";

const DEFAULT_SORT_KEY = "student_year.student_year_name_th";
const DEFAULT_SORT_DIRECTION = "ASC";
export default {
  name: "RegistrationForm",
  components: {
    BackofficeLayout,
    VueHtml2pdf,
    ApplicationPart
},
  data() {
    return {
      studentYear: [],
      registrationForm: null,
      summary: {
        total_student: 0,
        total_fee: 0,
        total_register_student: 0,
        total_confirmation_student: 0,
      },
      registrationPlan: [],
      keyword: "",
      selectedStudentYearId: "",
      options: {}, // v-data-table
      pages: 1,
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0,
      sort: DEFAULT_SORT_KEY,
      sortDirection: DEFAULT_SORT_DIRECTION,
      pageSizeOption: PAGE_SIZE_OPTIONS,
      loading: 0,
      registrationFormDetail: {},
      organizationDetail: null,
      studentDataList: [],
      reportTitle: null,
      programName: null,
    };
  },
  mounted() {
    this.init();
    // this.getStudentYear();
    this.getRegistrationFormById();
  },
  methods: {
    async downloadExcel() {
      try {
        this.loading++;
        const { data } = await services.exportExcelCalendar(
          this.registrationForm.id,
          `calendar_report_${this.registrationForm.id}`
        );
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.target = "_blank";
        a.href = downloadUrl;
        a.download = `calendar_report_${this.registrationForm.id}.xlsx`;
        document.body.appendChild(a);
        a.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    formatDateTime: (date) => {
      return dateUtils.formatDateTime(date);
    },
    async getStudentYear() {
      try {
        this.loading++;
        const {
          data: {
            data: { student_year },
          },
        } = await services.getStudentYear();
        this.studentYear = [
          ...student_year.map((item) => ({
            value: item.value,
            label_th: item.student_year_name_th,
            label_en: item.student_year_name_en,
          })),
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async getRegistrationFormById() {
      try {
        this.loading++;
        const id = this.$route.params?.id;
        const {
          data: { data },
        } = await services.getRegistrationCalendarById(id);
        this.registrationForm = data.registration_form;
        this.summary = data.summary;
        this.selectedStudentYearId = this.registrationForm.grade_level;
        await this.getRegistrationCalendarPlan();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    async getRegistrationCalendarPlan() {
      try {
        this.loading++;
        const id = this.$route.params?.id;
        const query = this.prepareQuery();
        const {
          data: { data },
        } = await services.getRegistrationCalendarPlanByFormId(id, query);
        this.registrationPlan = data.registration_plan;
        this.pages = data.total_page;
        this.total = data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading--;
      }
    },
    search() {
      const id = this.$route.params?.id;
      const query = this.prepareQuery();
      router.push({
        path: `/registration/calendar/${id}`,
        query: { ...query, keyword: this.keyword },
      });
    },
    changeStudentYear(value) {
      const id = this.$route.params?.id;
      const query = this.prepareQuery();
      router.push({
        path: `/registration/calendar/${id}/${value}`,
        query: { ...query, student_year: value },
      });
    },
    init() {
      const query = this.$route.query;
      const keyword = query.keyword || "";
      const studentYear = query?.student_year
      const page = query.page ? parseInt(query.page) : 1;
      const pageSize = query.page_size
        ? parseInt(query.page_size)
        : DEFAULT_PAGE_SIZE;
      const sort = query.sort ? query.sort.split(":") : "";
      const sortKey = sort?.[0] ?? DEFAULT_SORT_KEY;
      const sortDirection = sort?.[1] ?? DEFAULT_SORT_DIRECTION;
      this.keyword = keyword;
      this.selectedStudentYearId = studentYear ? parseInt(studentYear) : 0;
      this.page = page;
      this.pageSize = pageSize;
      this.sort = sortKey;
      this.sortDirection = sortDirection;

      if (this.selectedStudentYearId) this.getRegistrationCalendarPlan();
    },

    handleChangePage(newPage) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page: newPage },
      });
    },
    handleChangePageSize(newPageSize) {
      const query = this.prepareQuery();
      const path = this.$route.path;
      router.push({
        path,
        query: { ...query, page_size: newPageSize },
      });
    },
    handleChangeSort(key) {
      let direction = "desc";
      if (key === this.sort) {
        direction = OPPOSITE_SORT[this.sortDirection] || "desc";
      }
      const sort = `${key}:${direction}`;
      const path = this.$route.path;
      const query = this.prepareQuery();
      router.push({
        path,
        query: { ...query, sort },
      });
    },
    prepareQuery() {
      return {
        keyword: this.keyword,
        student_year: this.selectedStudentYearId,
        page: this.page,
        page_size: this.pageSize,
        sort: `${this.sort}:${this.sortDirection}`,
      };
    },
    // async downloadPdf(item) {
    //   try {
    //     this.loading++;
    //     const { data: { data: { organization }}} = await services.getOrganization();
    //     this.organizationDetail = organization;
    //     const planId = item.id
    //     const params = {
    //         status: 0,
    //     }
    //     const { data: { data: { registration_form, students }}} = await services.getRegistrationDownloadByIdAndPlanId(this.registrationForm?.id, planId, params);
    //     this.registrationFormDetail = registration_form
    //     this.studentDataList = students

    //     this.programName = this.$i18n.locale == 'th' ? item.program_name_th : item.program_name_en ?? item.program_name_th
    //     this.reportTitle = `${this.$t('message.common.applicantReport.exam_authorize_title')}`
    //     this.$nextTick(() => {
    //       this.$refs.html2pdf.generatePdf();
    //     });
    //   } catch (error) {
    //     console.error('Error downloading PDF:', error)
    //     this.$toast.error(this.$t('message.common.downloadError'));
    //   } finally {
    //     this.loading--;
    //   }
    // },
},
  computed: {
    pdfOption() {
      return {
        margin: 0,
        image: { type: "jpeg", quality: 0.98 },
        filename: "applicant_report.pdf",
        pagebreak: { mode: 'avoid-all', before: '.before', after: '.after', avoid: '.avoid' },
        html2canvas: { scale: 2, dpi: 900, letterRendering: true, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait", compress: false },
      }
    },
    pageSizeText() {
      return calculateCurrentPage(this.page, this.pageSize, this.total);
    },
    openingDateText() {
      if (!this.registrationForm || !this.registrationForm.opening_date)
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.opening_date,
        this.$i18n.locale
      );
    },
    closingDateText() {
      if (!this.registrationForm || !this.registrationForm.closing_date)
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.closing_date,
        this.$i18n.locale
      );
    },
    paymentEndDateText() {
      if (!this.registrationForm || !this.registrationForm.payment_end_date)
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.payment_end_date,
        this.$i18n.locale
      );
    },
    examAuthorizeAnnouncementDateText() {
      if (
        !this.registrationForm ||
        !this.registrationForm.exam_authorize_announcement_date
      )
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.exam_authorize_announcement_date,
        this.$i18n.locale
      );
    },
    examAuthorizeAnnouncementTimeText() {
      if (
        !this.registrationForm ||
        !this.registrationForm.exam_authorize_announcement_time
      )
        return "-";

      const suffix = this.$i18n.locale === "th" ? " น." : "";
      return `${this.registrationForm.exam_authorize_announcement_time}${suffix}`;
    },
    announcementExamResultDateText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm.announcement_exam_result_date)
      )
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.announcement_exam_result_date,
        this.$i18n.locale
      );
    },
    announcementExamResultTimeText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm.announcement_exam_result_time)
      )
        return "-";
      const suffix = this.$i18n.locale === "th" ? " น." : "";
      return `${this.registrationForm.announcement_exam_result_time}${suffix}`;
    },
    announcementExamResultDeadlineDateText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm.announcement_exam_result_deadline_date)
      )
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.announcement_exam_result_deadline_date,
        this.$i18n.locale
      );
    },
    reservedAnnouncementExamResultDateText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm.reserved_announcement_exam_result_date)
      )
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.reserved_announcement_exam_result_date,
        this.$i18n.locale
      );
    },
    reservedAnnouncementExamResultTimeText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm.reserved_announcement_exam_result_time)
      )
        return "-";
      const suffix = this.$i18n.locale === "th" ? " น." : "";
      return `${this.registrationForm.reserved_announcement_exam_result_time}${suffix}`;
    },
    reservedAnnouncementExamResultDeadlineDateText() {
      if (
        !this.registrationForm ||
        (this.registrationForm &&
          !this.registrationForm
            .reserved_announcement_exam_result_deadline_date)
      )
        return "-";
      return dateUtils.formatDateTime(
        this.registrationForm.reserved_announcement_exam_result_deadline_date,
        this.$i18n.locale
      );
    },
    feeText() {
      if (!this.registrationForm || !this.registrationForm.fee) return "-";
      return `${this.$options.filters.currency(
        this.registrationForm.fee
      )} ${this.$t("message.common.currency.baht")}`;
    },
    title() {
      if (!this.registrationForm) return "";
      return this.registrationForm.register_name;
    },
    breadcrumb() {
      const breadcrumb = [
        {
          text: this.$t("message.registration_form.candidate_list"),
          link: "/registration/calendar",
        },
      ];
      if (this.registrationForm) {
        breadcrumb.push({
          text: `${this.$t("message.common.academic_year")} ${
            this.registrationForm.semester_year
          }`,
        });
      }

      return breadcrumb;
    },
    headers() {
      return [
        {
          text: this.$t("message.common.grade_level"),
          value: `student_year_name_${this.$i18n.locale}`,
          sort: `student_year.student_year_name_${this.$i18n.locale}`,
          sortable: true,
          width: "15%",
        },
        {
          text: this.$t("message.common.curriculum"),
          value: `program_name_${this.$i18n.locale}`,
          sort: `program.program_name_${this.$i18n.locale}`,
          sortable: true,
          width: "20%",
        },
        {
          text: this.$t("message.common.required_amount"),
          value: "total_student",
          sort: "total_student",
          sortable: true,
          width: "17%",
        },
        {
          text: this.$t("message.registration_form.applicants"),
          value: "total_register",
          sort: "total_register",
          sortable: true,
          width: "15%",
        },
        {
          text: this.$t("message.registration_form.confirmed"),
          value: "total_successful_confirmation",
          sort: "total_successful_confirmation",
          sortable: true,
          width: "13%",
        },
        {
          text: this.$t("message.registration_form.application_fee"),
          value: "total_fee",
          sort: "total_fee",
          sortable: true,
          width: "18%",
        },
        { text: "", value: "action", width: "2%" },
      ];
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 24px 24px 24px;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;
  border-top: 1px solid #d7d6d8;
}

.statistic-panel {
  display: flex;
  gap: 14px;
}
.statistic {
  box-sizing: border-box;
  display: flex;
  gap: 14px;
  padding: 16px 12px;
  flex: 1;
  border: 1px solid #fff;
  border-radius: 10px;
}

.statistic-icon {
  font-size: 36px;
}
.statistic-caption {
  font-family: "Prompt", sans-serif;
  font-size: 14px;
  margin-bottom: 0;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.statistic-value {
  font-family: "Prompt", sans-serif;
  font-size: 24px;
  margin-bottom: 0;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.statistic--blue {
  background-color: rgba(111, 162, 204, 0.3);
  border-color: #7fa2cc;
}

.statistic--blue > .statistic-icon {
  color: #7fa2cc;
}

.statistic--navy {
  background-color: rgba(37, 93, 152, 0.3);
  border-color: #255d98;
}

.statistic--navy > .statistic-icon {
  color: #255d98;
}

.statistic--brown {
  background-color: rgba(191, 153, 131, 0.3);
  border-color: #bf9983;
}

.statistic--brown > .statistic-icon {
  color: #bf9983;
}

.statistic--orange {
  background-color: rgba(241, 153, 109, 0.3);
  border-color: #f1996d;
}

.statistic--orange > .statistic-icon {
  color: #f1996d;
}

.statistic--gold {
  background-color: rgba(153, 91, 0, 0.3);
  border-color: #995b00;
}

.statistic--gold > .statistic-icon {
  color: #995b00;
}

.radius-10px{
  border-radius:10px !important;
}

</style>
